import { clamp, isBetween } from './utils';
import { CLASS_NAMES, SELECTORS } from './constants';

function setupScrollNavigation() {
  [...document.querySelectorAll(SELECTORS.menu_item)].forEach((anchor) => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();

      const section = document.querySelector(this.getAttribute('href'));

      if (section) {
        section.scrollIntoView({
          behavior: 'smooth',
        });
      }
    });
  });
}

function setupActiveMenuItem() {
  const setActiveId = (id) => {
    const oldActiveItem = document.querySelector(SELECTORS.menu_item_active);

    if (oldActiveItem) {
      oldActiveItem.classList.remove(CLASS_NAMES.menu_item_active);
    }

    if (id) {
      const item = document.querySelector(`a[href*=${id}]`);

      if (item) {
        item.classList?.add(CLASS_NAMES.menu_item_active);
      }
    }
  };

  const listener = () => {
    const offset = window.innerHeight / 2;
    const scroll = window.pageYOffset;

    const position = SELECTORS.menu_items_id
      .map((id) => {
        const element = document.getElementById(id);

        if (!element) return { id, top: -1, bottom: -1 };

        const rect = element.getBoundingClientRect();
        const top = clamp(rect.top + scroll - offset);
        const bottom = clamp(rect.bottom + scroll - offset);

        return { id, top, bottom };
      })
      .find(({ top, bottom }, i, original) =>
        isBetween(scroll, top, original[i + 1]?.top || bottom)
      );

    setActiveId(position?.id || '');
  };

  listener();

  window.addEventListener('resize', listener);
  window.addEventListener('scroll', listener);
}

function setupMenu() {
  setupActiveMenuItem();
  setupScrollNavigation();
}

export { setupMenu };
